import { Box, Chip, Dialog, DialogContent, Divider, Grid2, Stack, Typography } from "@mui/material";
import React from "react";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import CommonButton from "../../../../component/Button";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import FileUpload from "./FileUpload";
import { CustomizeSpan } from "../../../jobs/style";

function AddMoreCandidate({
  addMoreCandidateDialogOpen,
  handleAddMoreCandidateDialogClose,
  handleAddMoreCandidateDragOver,
  handleAddMoreCandidateDragLeave,
  handleAddMoreCandidateDrop,
  handleAddMoreCandidateFileUpload,
  addMoreCandidateFiles,
  isAddMoreCandidateDragging,
  handleAddMoreCandidateDeleteFile,
  handleAddMoreCandidateClick,
  isLoading,
  isJem,
  disabled = false,
  buttonDisabled,
  title,
  buttonName,
  fileText,
}) {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={addMoreCandidateDialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          width: "500px",
          maxWidth: "none",
          borderRadius: "12px",
          background: "#FFF",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        },
      }}
    >
      <DialogContent>
        <Grid2 conatiner spacing={4}>
          <CommonGrid2
            size={12}
            display={"flex"}
            justifyContent={"space-between"}
            flexDirection={"row"}
            gap={"10px"}
            alignItems={"center"}
            marginBottom={"10px"}
          >
            <Typography fontSize={"18px"} color="#101828" fontWeight={600}>
              {title || "Add More Candidates"}
            </Typography>
            {/* <IconButton onClick={handleAddMoreCandidateDialogClose}>
              {<XCloseIco />}
            </IconButton> */}
            <CommonButton
              onClick={handleAddMoreCandidateDialogClose}
              padding={"10px"}
              background={"rgba(127, 86, 217, 0.04)"}
              border="rgba(127, 86, 217, 0.5)"
              height={"100%"}
              value={<XCloseIco />}
              boxShadow="0px 0px 10px 0px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 4px 0px rgba(0,0,0,0.12)"
              customStyle={{ top: "-10px", left: "14px" }}
            />
          </CommonGrid2>
               <Box sx={{ mb: 3 }}>
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 1 }}>
              
              <Typography fontSize="13px" fontWeight={400} color="#667085">
                (Please upload a clear and readable file only)
              </Typography>
              <Typography fontSize="13px" fontWeight={600} color="#F04438">
                *
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              gap={0.75}
              sx={{
                px: 1.5,
                py: 1,
                bgcolor: "#F9FAFB",
                border: "1px solid #EAECF0",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <Typography fontSize="11.5px" fontWeight={500} color="#667085">
                Supported formats:
              </Typography>
              {["PDF", "DOC", "DOCX"].map((fmt) => (
                <Chip
                  key={fmt}
                  label={fmt}
                  size="small"
                  sx={{
                    height: "22px",
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#6941C6",
                    bgcolor: "#F4EBFF",
                    border: "1px solid #E9D7FE",
                    borderRadius: "6px",
                    "& .MuiChip-label": { px: "8px" },
                  }}
                />
              ))}
              <Divider orientation="vertical" flexItem sx={{ mx: 0.5, borderColor: "#EAECF0" }} />
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography fontSize="11.5px" fontWeight={500} color="#667085">
                  Max size:
                </Typography>
                <Typography
                  fontSize="11.5px"
                  fontWeight={700}
                  color="#344054"
                  sx={{
                    px: 0.75,
                    py: 0.1,
                    bgcolor: "#F2F4F7",
                    borderRadius: "4px",
                    border: "1px solid #D0D5DD",
                  }}
                >
                  5 MB
                </Typography>
              </Stack>
            </Stack>
          </Box>
          <FileUpload
            onDragOver={handleAddMoreCandidateDragOver}
            onDragLeave={handleAddMoreCandidateDragLeave}
            onDrop={handleAddMoreCandidateDrop}
            onChange={handleAddMoreCandidateFileUpload}
            files={addMoreCandidateFiles}
            isDragging={isAddMoreCandidateDragging}
            handleDeleteFile={handleAddMoreCandidateDeleteFile}
            disabled={isLoading || disabled}
            isJem={isJem}
            fileText={fileText}
          />
          <CommonButton
            variant="contained"
            color="white"
            width={"100%"}
            background="#7F56D9"
            fontWeight="600"
            value={buttonName ? buttonName : isJem ? "Submit" : "Add New"}
            padding={"10px 0"}
            disabled={buttonDisabled}
            onClick={() => handleAddMoreCandidateClick()}
            loading={isLoading}
          />
        </Grid2>
      </DialogContent>
    </Dialog>
  );
}

export default AddMoreCandidate;
